<div class="app-full-height">
  <div fxLayout="column" fxLayoutGap="20px" class="m-4">
    <h1>Settings</h1>

    <mat-card appearance="outlined">
      <mat-card-content>
        <stripe-setup></stripe-setup>
      </mat-card-content>
    </mat-card>

    <mat-card appearance="outlined">
      <mat-card-content>
        <xero-setup></xero-setup>
      </mat-card-content>
    </mat-card>
    <mat-card appearance="outlined">
      <mat-card-content>
        <zoho-setup></zoho-setup>
      </mat-card-content>
    </mat-card>
    <mat-card appearance="outlined">
      <mat-card-content>
        <sage-setup></sage-setup>
      </mat-card-content>
    </mat-card>
    <mat-card appearance="outlined">
      <mat-card-content>
        <brc-setup></brc-setup>
      </mat-card-content>
    </mat-card>
    <mat-card appearance="outlined">
      <mat-card-content>
        <app-delivery-estimate-config></app-delivery-estimate-config>
      </mat-card-content>
    </mat-card>
    <mat-card appearance="outlined">
      <mat-card-content>
        <app-import-export></app-import-export>
      </mat-card-content>
    </mat-card>
  </div>
</div>
